"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorSuccess = '#00c616', exports.colorError = 'red', exports.colorWarning = '#FF8000', exports.colorInfo = '#0288d1';